// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAcpiY6_h_gm0UGOMAXTqrmLobjAMwaXck",
  authDomain: "litvill-assignments.firebaseapp.com",
  projectId: "litvill-assignments",
  storageBucket: "litvill-assignments.firebasestorage.app",
  messagingSenderId: "1075708119684",
  appId: "1:1075708119684:web:e6aae2b580f48e491850d1",
  measurementId: "G-X1MW4NQTMC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Export the services for use in other files
export { db, storage, auth };
export default app;